import React from "react";
import { Radar } from "react-chartjs-2";

const FinanceRadar = ({ comparisonData, target }) => {
  const data1 = {
    labels: [
      "寄付・会費率",
      "事業収入比率",
      "社会的支援収入比率",
      "収入多様性指標",
      "管理費比率",
      "正味財産・収益比率",
      "収益率",
    ],
    datasets: [
      {
        label: comparisonData["正味財産・収益比率"][0].name,
        backgroundColor: "rgba(179,181,198,0.2)",
        borderColor: "rgba(179,181,198,1)",
        pointBackgroundColor: "rgba(179,181,198,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(179,181,198,1)",
        data: [
          comparisonData["寄付・会費率"][0].data.slice(-1)[0],
          comparisonData["事業収入比率"][0].data.slice(-1)[0],
          comparisonData["社会的支援収入比率"][0].data.slice(-1)[0],
          comparisonData["収入多様性指標"][0].data.slice(-1)[0],
          comparisonData["管理費比率"][0].data.slice(-1)[0],
          comparisonData["正味財産・収益比率"][0].data.slice(-1)[0],
          comparisonData["収益率"][0].data.slice(-1)[0],
        ],
      },
    ],
  };

  const data2 = {
    labels: [
      "寄付・会費率",
      "事業収入比率",
      "社会的支援収入比率",
      "収入多様性指標",
      "管理費比率",
      "正味財産・収益比率",
      "収益率",
    ],
    datasets: [
      {
        label: comparisonData["正味財産・収益比率"][0].name,
        backgroundColor: "rgba(179,181,198,0.2)",
        borderColor: "rgba(179,181,198,1)",
        pointBackgroundColor: "rgba(179,181,198,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(179,181,198,1)",
        data: [
          comparisonData["寄付・会費率"][0].data.slice(-1)[0],
          comparisonData["事業収入比率"][0].data.slice(-1)[0],
          comparisonData["社会的支援収入比率"][0].data.slice(-1)[0],
          comparisonData["収入多様性指標"][0].data.slice(-1)[0],
          comparisonData["管理費比率"][0].data.slice(-1)[0],
          comparisonData["正味財産・収益比率"][0].data.slice(-1)[0],
          comparisonData["収益率"][0].data.slice(-1)[0],
        ],
      },

      {
        label: target,
        backgroundColor: "rgba(255,99,132,0.2)",
        borderColor: "rgba(255,99,132,1)",
        pointBackgroundColor: "rgba(255,99,132,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(255,99,132,1)",
        data: [
          comparisonData["寄付・会費率"][1].data.slice(-1)[0],
          comparisonData["事業収入比率"][1].data.slice(-1)[0],
          comparisonData["社会的支援収入比率"][1].data.slice(-1)[0],
          comparisonData["収入多様性指標"][1].data.slice(-1)[0],
          comparisonData["管理費比率"][1].data.slice(-1)[0],
          comparisonData["正味財産・収益比率"][1].data.slice(-1)[0],
          comparisonData["収益率"][1].data.slice(-1)[0],
        ],
      },
    ],
  };

  const options = {
    scale: {
      ticks: {
        beginAtZero: true,
        // max: 5,
        // min: 0,
        // stepSize: 1
      },
    },
  };

  return (
    <div>
      {comparisonData["事業収入比率"][1].data.lengths === 0 ? (
        <div style={{ transform: "scale(1.2)", marginTop: 70 }}>
          <Radar data={data1} options={options} />
        </div>
      ) : (
        <div style={{ transform: "scale(1.2)", marginTop: 70 }}>
          <Radar data={data2} options={options} />
        </div>
      )}
    </div>
  );
};

export default FinanceRadar;
